module.exports = __webpack_public_path__ + "4e5c80fe.svg";